(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "performance-now"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("performance-now"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.performanceNow);
    global.createProfilerMiddleware = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _performanceNow) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.createProfilerMiddleware = void 0;
  _performanceNow = _interopRequireDefault(_performanceNow);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  const createProfilerMiddleware = config => () => next => action => {
    const {
      enabled = false
    } = config;

    if (!enabled) {
      return next(action);
    }

    const start = (0, _performanceNow.default)();
    const result = next(action);
    const end = (0, _performanceNow.default)();
    /* eslint-disable no-param-reassign */

    if (!action.meta) {
      action.meta = {};
    }

    action.meta.executionTimeInMs = end - start;
    /* eslint-enable no-param-reassign */

    return result;
  };

  _exports.createProfilerMiddleware = createProfilerMiddleware;
});